import type { ReactNode } from 'react';

export const ButtonsContainer = ({ children }: { children: ReactNode }) => {
  return <div className='ml-2 flex gap-2'>{children}</div>;
};
